import { StoryblokSlugPrefixToHide } from '~/utils/storyblok-constants';

export default defineNuxtRouteMiddleware((to) => {
    const { isDraftModeEnabled } = useDraftMode();

    if (!isDraftModeEnabled.value && to.path.includes(StoryblokSlugPrefixToHide)) {
        return abortNavigation({
            statusCode: 404,
            statusMessage: 'Not Found'
        });
    }
});
